import { render, staticRenderFns } from "./QuestionQuizInstruction.vue?vue&type=template&id=5c368172&scoped=true"
import script from "./QuestionQuizInstruction.vue?vue&type=script&lang=js"
export * from "./QuestionQuizInstruction.vue?vue&type=script&lang=js"
import style0 from "./QuestionQuizInstruction.vue?vue&type=style&index=0&id=5c368172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c368172",
  null
  
)

export default component.exports